import React from "react";
import { authService } from "..";

export default class RedirectingToLoginProvider extends React.Component {
  componentDidMount() {
    authService.signIn();
  }

  render() {
    return (
      <div>
        <h2>Authenticating...</h2>
      </div>
    );
  }
}
